export const OPEN_ASSIGN_CIC_TO_USER_MODAL = 'OPEN_ASSIGN_CIC_TO_USER_MODAL';
export const CLOSE_ASSIGN_CIC_TO_USER_MODAL = 'CLOSE_ASSIGN_CIC_TO_USER_MODAL';
export const CLOSE_ASSIGN_CIC_TO_USER_ERROR = 'CLOSE_ASSIGN_CIC_TO_USER_ERROR';

function openAssignCicToUserModal(cicAlertList) {
  return {
    type: OPEN_ASSIGN_CIC_TO_USER_MODAL,
    isAssignCicToUserModalShown: true,
    cicAlertList
  };
}

function closeAssignCicToUserModal() {
  return {
    type: CLOSE_ASSIGN_CIC_TO_USER_MODAL,
    isAssignCicToUserModalShown: false
  };
}

function closeAssignCicToUserError() {
  return {
    type: CLOSE_ASSIGN_CIC_TO_USER_ERROR,
    isAssignCicToUserModalShown: true
  };
}

export function showAssignCicToUserModal(cicAlertList) {
  return (dispatch) => {
    dispatch(openAssignCicToUserModal(cicAlertList));
  };
}

export function hideAssignCicToUserModal() {
  return (dispatch) => {
    dispatch(closeAssignCicToUserModal());
  };
}

export function hideAssignCicToUserError() {
  return (dispatch) => {
    dispatch(closeAssignCicToUserError());
  };
}
